import { NatalChartBlockValue } from '../entities';

export type ContentState = {
  natalChartBlockValues: Array<NatalChartBlockValue>;
};

export const contentInitialState: ContentState = {
  natalChartBlockValues: [],
};
